export default __webpack_public_path__ + "static/media/GothamRnd-Book.1e2eac8a.otf";